import { Button, SearchInput } from '../../shared/ui'

const INDUSTRIES = [
  'Information Technology & Services',
  'SaaS',
  'Cybersecurity',
  'Financial Services',
  'Healthcare',
  'Manufacturing',
  'Telecommunications',
] as const

interface Props {
  search: string
  industry: string
  onSearchChange: (value: string) => void
  onIndustryChange: (value: string) => void
}

/**
 * Search box + industry filter + Fix data + + Account.
 * The two buttons still call the legacy window functions
 * (`openCleanupModal`, `openAddAccount`); the modals/drawer migrate in a
 * later PR. The legacy save handlers dispatch `accounts:changed` on the
 * bus, which `useAccounts` listens for.
 *
 * "Enrich All" is hidden: it calls the brand-scrape edge function, which
 * is not in the deploy list. Put it back when brand-scrape ships.
 */

export function AccountsToolbar({ search, industry, onSearchChange, onIndustryChange }: Props) {
  const onCleanupClick = () => {
    const fn = (window as unknown as { openCleanupModal?: () => void }).openCleanupModal
    fn?.()
  }
  const onAddClick = () => {
    const fn = (window as unknown as { openAddAccount?: () => void }).openAddAccount
    fn?.()
  }

  return (
    <div className="toolbar">
      <SearchInput value={search} onChange={onSearchChange} placeholder="Search company, domain…" />
      <select
        className="filter-select"
        value={industry}
        onChange={(e) => onIndustryChange(e.target.value)}
      >
        <option value="">All Industries</option>
        {INDUSTRIES.map((i) => (
          <option key={i}>{i}</option>
        ))}
      </select>
      <Button variant="secondary" onClick={onCleanupClick}>
        Fix data
      </Button>
      <Button onClick={onAddClick}>+ Account</Button>
    </div>
  )
}
